import { ReactComponent as DropDown } from '../../src/assets/images/icons/dropdown.svg';

export default function componentStyleOverrides(theme) {
    // const bgColor = theme.colors?.grey50;
    return {
        hr: {
            paddingX: '15px'
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '4px',
                    borderColor: '#03045E',
                    color: 'var(--primary, #03045E)', // Set the color for outlined buttons globally
                    '&.MuiButton-primary': {
                        backgroundColor: '#03045E'
                    }
                }
            },
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        borderColor: `#03045E`
                    }
                }
            ]
        },

        MuiMenuItem: {
            // defaultProps: {
            //     // disableRipple: true,
            //     disableTouchRipple: true
            // },
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                    border: 'none',
                    width: '100%',
                    '&.Mui-selected': {
                        backgroundColor: '#D9EAFF !important',
                        width: '100%'
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#D9EAFF !important',
                        width: '100%'
                    }
                }
            }
        },
        // MuiMenuItem: {
        //     backgroundColor: 'white',
        //     disableRipple: true, // Remove onClick background effects globally
        //     border: 'none',
        //     styleOverrides: {
        //         root: {
        //             border: 'none',
        //             disableRipple: true, // Remove onClick background effects globally
        //             backgroundColor: 'white',
        //             width: '100%',
        //             '&.Mui-selected': {
        //                 disableRipple: true, // Remove onClick background effects globally
        //                 // Your styles here
        //                 backgroundColor: '#D9EAFF !important',
        //                 width: '100%'
        //             },
        //             '&.Mui-selected:hover': {
        //                 disableRipple: true, // Remove onClick background effects globally
        //                 // Your styles here #D9EAFF
        //                 backgroundColor: '#D9EAFF !important',
        //                 width: '100%'
        //             }
        //         }
        //     }
        // },
        MuiTooltip: {
            defaultProps: {
                placement: 'right-start',
                arrow: true
                // disablePortal: true
                // placement: 'right', // ✅ sets default tooltip position globally
                // arrow: true // (optional) adds arrow by default
            },
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#D9EAFF !important',
                    // fontFamily: 'Open Sans Regular', // Set your desired font family
                    color: '#03045E', // Optional: text color
                    fontSize: '14px' // Optional: font size
                }
            }
        },
        MuiSelect: {
            defaultProps: {
                IconComponent: DropDown
            },
            styleOverrides: {
                select: {
                    color: '#03045E',
                    borderColor: '#03045E',
                    backgroundColor: 'none'
                },
                icon: {
                    marginTop: '3px',
                    marginRight: '12px' //'10px'
                },
                '&.MuiSelect-iconOpen': {
                    color: '#03045E',
                    borderColor: '#03045E',
                    width: '20px',
                    height: '38px',
                    marginRight: '12px', //'10px',
                    marginBottom: '10px'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: '#03045E', //theme.colors?.textDark,
                    padding: '0px'
                }
                // title: {
                //     fontSize: '1.125rem'
                // }
            }
        },
        // MuiCardContent: {
        //     styleOverrides: {
        //         root: {
        //             padding: '24px'
        //         }
        //     }
        // },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: '#03045E', //theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: '#03045E' //theme.darkTextPrimary,
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: '#03045E',
                    fontSize: '16px',
                    padding: '10px',
                    '&::placeholder': {
                        color: '#03045E', //theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        // MuiButtonBase: {
        //     defaultProps: {
        //         disableRipple: true,
        //         disableTouchRipple: true
        //     }
        // },
        MuiListItemButton: {
            // defaultProps: {
            //     disableRipple: true,
            //     disableTouchRipple: true
            // },
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    // background: bgColor,
                    borderColor: '#03045E !important',
                    borderRadius: '5px',
                    color: '#03045E',
                    // padding: '10px',
                    height: '40px',
                    '&.MuiInputBase-multiline': {
                        padding: 1,
                        borderColor: '#03045E'
                    },
                    '& fieldset': {
                        borderWidth: 1, // Default border width
                        borderColor: '#03045E'
                    },
                    '&:hover fieldset': {
                        borderWidth: 2, // Border width on hover
                        borderColor: '#03045E'
                    },
                    '&.Mui-focused fieldset': {
                        borderWidth: 2, // Border width when focused
                        borderColor: '#03045E !important'
                    }, // Default border color
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#03045E'
                    },
                    // Border color on hover
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#03045E'
                    },
                    // Border color when focused
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#03045E'
                    }
                },
                input: {
                    fontWeight: 600,
                    // background: '#FAFAFA',
                    borderColor: '#03045E',
                    color: '#03045E',
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        color: '#03045E',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0,
                            color: '#03045E'
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: '5px' //`${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#03045E',
                    fontSize: '14px',
                    // backgroundColor: '#FAFAFA',
                    transform: 'translate(14px, 8px) scale(1)',
                    '&.Mui-focused': {
                        // Add your custom styles for the focused state here
                        transform: 'translate(14px, -9px) scale(0.75)',
                        color: '#03045E' // For example, change the color to red
                    },
                    '&.MuiFormLabel-filled': {
                        transform: 'translate(14px, -9px) scale(0.75)'
                    },
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -9px) scale(0.75)' // <- explicitly handle shrink
                    }
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: '#03045E' //theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: '#03045E' //theme?.colors?.primaryLight
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                root: {
                    paper: {
                        border: 'none'
                    }
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#03045E !important'
                    // fontSize: '1rem'
                }
                // body2: {
                //     fontSize: '1rem'
                // },
                // span: {
                //     color: '#64DFDF !important'
                // }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: '#03045E ',
                    fontWeight: 100
                    // borderColor: '#03045E',
                    // borderWidth:'90%'
                }
            }
        }
    };
}
